<script lang="ts">
import { onMount } from 'svelte';
import type { GameEntry } from "types";

import GameFolder from './GameFolder.svelte';
import GameLink from './GameLink.svelte';
import DiscordLogo from './DiscordLogo.svelte';

let game_data: GameEntry[] = [];

onMount(() => {
	const game_data_request = new Request("/game-data.json");
	fetch(game_data_request)
	.then(response => response.json())
	.then((data) => { game_data = data; })
})
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
		min-height: 100%;
		max-width: 840px;
		box-sizing: border-box;
		font-family: Helvetica, Arial, sans-serif;

		user-select: none;
	}

	div.intro {
		width: 800px;
		margin: 3rem auto;
	}

	div.intro > * {
		margin: 0 auto;
	}

	div.backroom {
		margin: 3rem auto;
	}

	div.bottom-text {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		text-align: center;
		font-size: 75%;
	}

	p.caption {
		font-size: 150%;
		line-height: 1.3;
	}

	a.discord-link {
		color: #7289DA;
	}
</style>

<div>
	<main>
		<img src="ecxp-logo.png" alt="ECXP logo" />
		<div>Coming soon!</div>
	</main>	
</div>